import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  images: string []= [];
  node: any;
  constructor() { }
  ngOnInit() {
    this.images = [
      'proyecto1.jpg',
      'proyecto2.jpg',
      'proyecto3.jpg',
      'proyecto4.jpg',
      'proyecto5.jpg',
      'proyecto6.jpg'
    ];
    this.loadScript('assets/js/appcarousel.js');
  }

  loadScript(url) {
    // console.log('preparing to load...')
    this.node = document.createElement('script');
    this.node.src = url;
    this.node.type = 'text/javascript';
    document.getElementsByTagName('body')[0].appendChild(this.node);
 }

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/components/home/home.component.ts